import z from "zod";

import { surrealRecordSchema } from "./surreal-record";

export enum ContractStatus {
  ACTIVE = "active",
  INACTIVE = "inactive",
}

export enum ContractInvoiceType {
  MONTHLY = "monthly",
  QUARTERLY = "quarterly",
  SEMI_ANNUALLY = "semi-annually",
  ANNUALLY = "annually",
}

export const contractSchema = surrealRecordSchema.extend({
  title: z.string(),
  description: z.string().optional(),
  tags: z.array(z.string()),
  status: z.nativeEnum(ContractStatus),
  cost: z.coerce.number().optional(),
  invoiceType: z.nativeEnum(ContractInvoiceType).optional(),
  fromDate: z.coerce.date(),
  toDate: z.coerce.date().optional(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type Contract = z.infer<typeof contractSchema>;
